"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-lines-per-function */
const React = __importStar(require("react"));
const base_form_1 = __importDefault(require("@/components/base-form"));
const buttons_1 = require("@/components/base-form/buttons");
const fields_1 = require("@/components/base-form/fields");
const form_error_1 = __importDefault(require("@/components/base-form/form-error"));
const constants_1 = __importStar(require("@/constants"));
const services_1 = require("@/helpers/services");
const api_payloads_1 = require("@/redux/api-payloads");
const field_names_1 = require("../field-names");
const schemas_1 = require("../schemas");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const initialValues = {
    [field_names_1.SignUpFieldNames.email]: '',
    [field_names_1.SignUpFieldNames.password]: '',
    [field_names_1.SignUpFieldNames.firstName]: '',
    [field_names_1.SignUpFieldNames.tos]: false,
};
const initialErrors = {
    [field_names_1.SignUpFieldNames.email]: constants_1.default.general.requiredField('Email'),
    [field_names_1.SignUpFieldNames.password]: constants_1.default.general.requiredField('Password'),
    [field_names_1.SignUpFieldNames.tos]: constants_1.default.general.requiredField('Terms of Service'),
};
const SignUpForm = () => (React.createElement(React.Fragment, null,
    React.createElement(base_form_1.default, { initialValues: initialValues, validationSchema: schemas_1.SignUpSchema, onSubmitPayload: api_payloads_1.signUpPayload, formKey: services_1.endpoints.signup, initialErrors: initialErrors },
        React.createElement("div", { className: styles_scss_1.default.signUpInputs },
            React.createElement("div", { className: styles_scss_1.default.signUpRow },
                React.createElement(fields_1.TextInputField, { name: field_names_1.SignUpFieldNames.firstName, label: constants_1.default.signup.firstName, placeholder: constants_1.default.signup.firstName, accessory: {
                        default: constants_1.Images.userCheck,
                        active: constants_1.Images.userCheckActive,
                        error: constants_1.Images.userCheckError,
                    } })),
            React.createElement("div", { className: styles_scss_1.default.signUpRow },
                React.createElement(fields_1.TextInputField, { name: field_names_1.SignUpFieldNames.email, label: constants_1.default.signup.email, placeholder: constants_1.default.signup.email, accessory: {
                        default: constants_1.Images.mail,
                        active: constants_1.Images.mailActive,
                        error: constants_1.Images.mailError,
                    } })),
            React.createElement("div", { className: styles_scss_1.default.signUpRow },
                React.createElement(fields_1.PasswordField, { name: field_names_1.SignUpFieldNames.password, label: constants_1.default.signup.password, placeholder: constants_1.default.signup.password })),
            React.createElement("div", { className: styles_scss_1.default.signUpRow },
                React.createElement(fields_1.CheckboxInputField, { label: React.createElement(React.Fragment, null,
                        React.createElement("span", null, constants_1.default.signup.iAcceptThe),
                        React.createElement("a", { target: "_blank", rel: "noreferrer", className: styles_scss_1.default.toc, href: constants_1.Links.ToS }, constants_1.default.signup.termsAndConditions)), name: field_names_1.SignUpFieldNames.tos, id: "TOS" }))),
        React.createElement(form_error_1.default, { formKey: services_1.endpoints.signup }),
        React.createElement("div", { className: styles_scss_1.default.buttons },
            React.createElement(buttons_1.SubmitButton, { disableOnErrors: true, title: constants_1.default.signup.signUp, className: styles_scss_1.default.btn })))));
exports.default = SignUpForm;
